<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>预警邮件管理</span>
      <div>
        <el-button v-if="$hasPermission('mall:stock-warn-email:save')" type="primary" size="mini" @click="openCreate">新增邮箱</el-button>
      </div>
    </div>

    <div class="search-bar search-wrap">
      <el-input
        v-model.trim="query.email"
        placeholder="请输入邮箱"
        clearable
        style="width: 260px"
        @keyup.enter.native="handleSearch"
      />
      <el-select v-model="query.status" clearable placeholder="状态" style="width: 140px">
        <el-option :value="1" label="启用" />
        <el-option :value="0" label="停用" />
      </el-select>
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column prop="email" label="邮箱" min-width="240" />
      <el-table-column prop="remark" label="备注" min-width="220" show-overflow-tooltip />
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'info'" size="mini">
            {{ row.status === 1 ? '启用' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="180" />
      <el-table-column prop="updateTime" label="更新时间" width="180" />
      <el-table-column label="操作" width="260" fixed="right">
        <template slot-scope="{ row }">
          <el-button v-if="$hasPermission('mall:stock-warn-email:update')" size="mini" @click="openEdit(row)">编辑</el-button>
          <el-button
            v-if="$hasPermission('mall:stock-warn-email:update')"
            :type="row.status === 1 ? 'warning' : 'success'"
            size="mini"
            @click="toggleStatus(row)"
          >
            {{ row.status === 1 ? '停用' : '启用' }}
          </el-button>
          <el-button v-if="$hasPermission('mall:stock-warn-email:delete')" size="mini" type="danger" @click="remove(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog :title="form.id ? '编辑预警邮箱' : '新增预警邮箱'" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
        <el-form-item label="邮箱" prop="email">
          <el-input v-model.trim="form.email" placeholder="请输入接收预警的邮箱" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model.trim="form.remark" type="textarea" :rows="3" placeholder="可填写接收人或用途" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">停用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          v-if="$hasPermission(form.id ? 'mall:stock-warn-email:update' : 'mall:stock-warn-email:save')"
          type="primary"
          @click="save"
        >
          保存
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'

function defaultForm () {
  return {
    id: null,
    email: '',
    remark: '',
    status: 1
  }
}

function defaultQuery () {
  return {
    page: 1,
    limit: 10,
    email: '',
    status: null
  }
}

export default {
  data () {
    return {
      query: defaultQuery(),
      total: 0,
      list: [],
      dialogVisible: false,
      form: defaultForm(),
      rules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.load()
  },
  methods: {
    async load () {
      const { data } = await http.get('/mall/stock-warn-email/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    openCreate () {
      this.form = defaultForm()
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    async openEdit (row) {
      const { data } = await http.get(`/mall/stock-warn-email/info/${row.id}`)
      const info = data.data || {}
      this.form = {
        id: info.id,
        email: info.email || '',
        remark: info.remark || '',
        status: Number(info.status == null ? 1 : info.status)
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    toggleStatus (row) {
      const nextStatus = row.status === 1 ? 0 : 1
      const actionText = nextStatus === 1 ? '启用' : '停用'
      this.$confirm(`确定${actionText}预警邮箱“${row.email}”吗？`, '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/mall/stock-warn-email/status', {
          id: row.id,
          status: nextStatus
        })
        if (data.code === 0) {
          this.$message.success(`预警邮箱${actionText}成功`)
          this.load()
        }
      })
    },
    save () {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        const payload = {
          id: this.form.id,
          email: this.form.email,
          remark: this.form.remark,
          status: this.form.status
        }
        const url = this.form.id ? '/mall/stock-warn-email/update' : '/mall/stock-warn-email/save'
        const { data } = await http.post(url, payload)
        if (data.code === 0) {
          this.$message.success(this.form.id ? '预警邮箱修改成功' : '预警邮箱新增成功')
          this.dialogVisible = false
          this.load()
        }
      })
    },
    remove (row) {
      this.$confirm(`确定删除预警邮箱“${row.email}”吗？`, '提示', { type: 'warning' }).then(async () => {
        const { data } = await http.post('/mall/stock-warn-email/delete', [row.id])
        if (data.code === 0) {
          this.$message.success('预警邮箱删除成功')
          this.load()
        }
      })
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.pagination-bar {
  margin-top: 12px;
  text-align: right;
}
</style>
